<div class="title">
  <p-heading [size]="'x-large'" [tag]="'h3'">Education Budget Corrections</p-heading>

  <p-link
    [hideLabel]="(mediaMaxXs$ | async) ?? false"
    [iconSource]="'assets/icons/add.svg'"
    [variant]="'secondary'"
  >
    <a [routerLink]="'/edu-budget-corrections/create'">Create New Education Budget Correction</a>
  </p-link>
</div>

<p-divider aria-hidden="true" />

<section class="section">
  <div class="breadcrumbs">
    <p-link-pure [hideLabel]="true" [iconSource]="'assets/icons/arrow-left.svg'">
      <a [routerLink]="'/edu-budget-corrections'">All Education Budget Corrections</a>
    </p-link-pure>

    <p-heading
      *ngrxLet="eduBudgetCorrection$ | async as eduBudgetCorrection"
      [size]="'large'"
      [tag]="'h4'"
    >
      {{ eduBudgetCorrection ? (eduBudgetCorrection.date | date) : '&nbsp;' }}
    </p-heading>
  </div>
</section>

<section class="section">
  <p-heading class="section-heading" [size]="'medium'" [tag]="'h4'">
    <div class="content">
      <p-icon [source]="'assets/icons/info.svg'" />
      <span>Education Budget Correction Details</span>
    </div>
  </p-heading>

  <ng-container
    *ngrxLet="
      eduBudgetCorrection$ as eduBudgetCorrection;
      error as eduBudgetCorrectionError;
      suspenseTpl: spinner
    "
  >
    <div *ngIf="eduBudgetCorrectionError">
      <p-button-pure
        [hideLabel]="true"
        [iconSource]="'assets/icons/refresh.svg'"
        [size]="'large'"
        (click)="reloadEduBudgetCorrection()"
      >
        Reload Education Budget Correction Details
      </p-button-pure>
    </div>

    <div
      *ngIf="!eduBudgetCorrectionError && eduBudgetCorrection"
      class="edu-budget-correction-details"
    >
      <div>
        <p-text [weight]="'semi-bold'">Person:</p-text>
        <p-text>
          {{ eduBudgetCorrection.user.firstName }} {{ eduBudgetCorrection.user.lastName }}
        </p-text>
      </div>

      <div>
        <p-text [weight]="'semi-bold'">Amount:</p-text>
        <p-text>{{ eduBudgetCorrection.amount | opaCurrency: null : true }}</p-text>
      </div>

      <div *ngIf="eduBudgetCorrection.description">
        <p-text [weight]="'semi-bold'">Description:</p-text>
        <p-text>{{ eduBudgetCorrection.description }}</p-text>
      </div>
    </div>
  </ng-container>
</section>

<ng-template #spinner>
  <div class="loading-spinner"><p-spinner /></div>
</ng-template>
